import { BaseSchemaBuilder } from '@/views/checkouts/schemas/baseSchema';
import * as yup from 'yup';

export const sharedHellasDirectFields = (
    firstDriverAdditionalPremiumAge,
    secondDriverAdditionalPremiumAge,
    firstDriverAdditionalPremiumLicenseYears,
    secondDriverAdditionalPremiumLicenseYears,
    legalEntity,
    secondDriver,
    discountEntity,
    vehicleType
) => {
    let schema = {
        ...BaseSchemaBuilder(false, false, legalEntity, !legalEntity, discountEntity),
        name2: yup.string().when('only_driver', {
            is: false,
            then: s => s.required(),
        }),
        surname2: yup.string().when('only_driver', {
            is: false,
            then: s => s.required(),
        }),
    };

    if (legalEntity) {
        schema = {
            ...schema,
            driver_name: yup.string().required(),
            driver_surname: yup.string().required(),
        };
    }

    return schema;
};


export const sharedHellasDirectSchemaBuilder = (...args) => yup.object(sharedHellasDirectFields(...args));
export default sharedHellasDirectSchemaBuilder;
